import {NgModule} from '@angular/core';
import {DocumentViewComponent} from '@components/laboratory-documents/components/document-view/document-view.component';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ModalModule} from '@components/modal/modal.module';
import {LayoutModule} from '../../layout-components/layout.module';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {DocumentFormComponent} from '@components/laboratory-documents/components/document-form/document-form.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {DocumentAddButtonComponent} from '@components/laboratory-documents/components/document-add-button/document-add-button.component';
import {DocumentApiService} from '@components/laboratory-documents/services/document.api.service';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormFieldModule,
        ModalModule,
        LayoutModule,
        FilePreviewModule,
        FilesUploaderModule,
        IconsModule,
    ],
    exports: [
        DocumentViewComponent,
        DocumentAddButtonComponent,
    ],
    declarations: [
        DocumentViewComponent,
        DocumentFormComponent,
        DocumentAddButtonComponent,
    ],
    providers: [
        DocumentApiService,
    ],
})
export class LaboratoryDocumentsModule {
}
